import { trackEvent } from '$app/analytics/helpers.js';
const TOAST_RESPONDED_KEY = 'tmp-toast-closed';

class ToastComponent extends HTMLElement {
  get eventData() {
    return {
      identifier: this.dataset.id,
      title: this.dataset.title,
    };
  }

  get closeButton() {
    return this.querySelector('.toast-close-button');
  }

  connectedCallback() {
    if (this.shouldShow()) {
      this.show();
      this.closeButton.addEventListener('click', this.close.bind(this));
    } else {
      trackEvent('toast_not_shown', this.eventData);
      this.remove();
    }
  }

  show() {
    this.classList.add('toast-active');
    trackEvent('toast_banner_impression', this.eventData);
  }

  close() {
    this.classList.remove('toast-active');
    this.addEventListener(
      'transitionend',
      () => {
        this.remove();
      },
      { once: true }
    );
    trackEvent('toast_banner_closed', this.eventData);
    try {
      window.sessionStorage.setItem(TOAST_RESPONDED_KEY, true);
    } catch {
      trackEvent('toast_session_access_denied', this.eventData);
    }
  }

  shouldShow() {
    return !window.sessionStorage.getItem(TOAST_RESPONDED_KEY);
  }
}

if (!window.customElements.get('tmp-toast')) {
  window.ToastComponent = ToastComponent;
  window.customElements.define('tmp-toast', ToastComponent);
}
